{
  "field_required": "This field is required",
  "title": "Title",
  "number": "number",
  "team_submit": "Submit team"
}
